import { Button, Tooltip } from "@mui/material";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { isAxiosError } from "axios";
import { format, isToday } from "date-fns";
import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ArrowRepeatIcon16pxSvg from "../../../assets/images/icons/ArrowRepeatIcon16pxSvg";
import NoRowOverlay from "../../../assets/images/icons/NoRowOverlay";
import { getEventList } from "../../../axios/Eventlog/EventLogApi";
import { StyledDataGrid } from "../../../components/StyledComponents";
import { useAuth } from "../../../context/AuthContext";
import { useSettings } from "../../../context/SettingsContext";
import { generateTranslateMuiTable } from "../../../utils/Function/commonFunction";
import CustomGridToolbarQuickFilter from "../CustomGridToolbarQuickFilter";
import CustomPagination from "../CustomPagination";
import { formatDateTimeString } from "./../../../utils/FormatDateTimeString/dateUtils";
import Cookies from "js-cookie";
import { useLoading } from "../../../context/LoadingContext";
import CustomColumnsPanel from "../../../components/CustomColumnsPanel";
import { DateTime } from "luxon";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getUserList } from "../../../axios/User/UserApi";
import EditNew20pxSvg from "../../../assets/images/icons/EditNew20pxSvg";
import DeleteIcon16pxSvg from "../../../assets/images/icons/DeleteIcon16pxSvg";
import EditEventDialog from "./EditEventDialog";
import EditEventDialogByUser from "./EditEventDialogByUser";
import RemoveEventDialog from "./RemoveEventDialog";
import RemoveRequestEventDialog from "./RemoveRequestEventDialog";

dayjs.extend(utc);
dayjs.extend(timezone);

export const EVENT_STATUS = {
  checkInOut: 0,
  missingCheckIn: 1,
  missingCheckOut: 2,
};

const CustomToolbar = ({ onRefresh, localeText }) => {
  const { t } = useTranslation();
  const { profile } = useAuth();

  return (
    <GridToolbarContainer className="flex justify-between items-center mb-2">
      <div className="flex items-center flex-wrap gap-3">
        {/* <GridToolbarColumnsButton localeText={localeText} />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <Tooltip title={t("button.refresh-data")}>
          <Button className="justify-end" onClick={onRefresh}>
            <ArrowRepeatIcon16pxSvg />
          </Button>
        </Tooltip> */}
      </div>

      <CustomGridToolbarQuickFilter fullWidth/>
    </GridToolbarContainer>
  );
};

const EventsGridInfoTable = ({
  isShowErrorLog,
  refreshData,
  onRowSelection,
  selectedDate,
  selectedShift,
  selectedUser,
  onRefresh,
  selectGroup,
  isShowEnableLog,
  dispalyWeek,
  onErrorUsersChange = () => { },
  usersData = [],
  shiftsData = [],
}) => {
  const {
    genaralSettingDateFormat,
    genaralSettingTimeFormat,
    dateTimeFormat,
    profile,
    isAdmin,
    isEmployee,
    genaralSettingTimeZone
  } = useAuth();
  const { t, i18n } = useTranslation();
  const { settings } = useSettings();
  const language = useSelector((state) => state.languageR.language);
  const currentLang = i18n.language;
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
  const [textSearch, setTextSearch] = useState("");
  const [rowData, setRowData] = useState([]);
  const [gridLoading, setGridLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [rowSelectData, setRowSelectData] = useState({});
  const [rowCount, setRowCount] = useState(0);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [filteredRowCount, setFilteredRowCount] = useState(0);
  const [show, hide] = useLoading();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [openEditEvent, setOpenEditEvent] = useState(false);
  const [openEditEventByUser, setOpenEditEventByUser] = useState(false);
  const [openRemoveEvent, setOpenRemoveEvent] = useState(false);
  const [openRemoveRequestEvent, setOpenRemoveRequestEvent] = useState(false);
  // const [countColumnShow, setCountColumShow] = useState(0);
  const defaultColumnVisibility = {
    fullName: true,
    employeeCode: true,
    shiftName: true,
    shiftStart: false,
    directionAndStatus: true,
    sensorData: false,
    timeGMT: false,
    eventTime: true,
    timeZone: false,
    address: false,
    deviceCode: false,
    deviceDescription: false,
    deviceOS: false,
    clientAppName: false,
    createdTime: false,
    modifiedTime: false,
    modifiedBy: false,
    description: false,
    restrictionGroupName: false,
    option: true,
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    defaultColumnVisibility
  );

  const buildFromToByMonthWithTZ = (selectedDate, timeZone) => {
    const base = DateTime.fromISO(
      typeof selectedDate === "string"
        ? selectedDate
        : DateTime.fromJSDate(selectedDate).toISODate(),
      { zone: timeZone }
    );

    return {
      from: base.startOf("month").toUTC().toISO(),
      to: base.endOf("month").toUTC().toISO(),
    };
  };

  const buildFromToByDateWithTZ = (selectedDate, timeZone) => {
    const base = DateTime.fromISO(
      typeof selectedDate === "string"
        ? selectedDate
        : DateTime.fromJSDate(selectedDate).toISODate(),
      { zone: timeZone }
    );

    return {
      from: base.startOf("day").toUTC().toISO(),
      to: base.endOf("day").toUTC().toISO(),
    };
  };


  const emailUser = profile?.email;
  const handleColumnVisibilityChange = (newModel) => {
    setColumnVisibilityModel(newModel);
    Cookies.set(`EventsGridInfoTable_${emailUser}`, JSON.stringify(newModel), {
      expires: 90,
      path: "/",
    });
  };

  useEffect(() => {
    const saved = Cookies.get(`EventsGridInfoTable_${emailUser}`);
    if (saved) {
      setColumnVisibilityModel(JSON.parse(saved));
    }
  }, []);

  function countVisibleColumns() {
    return (
      Object.values(columnVisibilityModel).filter((value) => value === true)
        .length - 2
    );
  }

  // const isFewColumns = countVisibleColumns() <= 4;
  const visibleColumnCount = countVisibleColumns();
  const isFewColumns = visibleColumnCount > 0 && visibleColumnCount <= 3;

  function formatTime(input, format) {
    const [hour, minute, second] = input.split(":");

    return format
      .replace("HH", hour.padStart(2, "0"))
      .replace("mm", minute.padStart(2, "0"))
      .replace("ss", second.padStart(2, "0"))
      .replace("h", (parseInt(hour) % 12 || 12).toString().padStart(2, "0")) // 12-hour
      .replace("a", parseInt(hour) >= 12 ? "PM" : "AM");
  }

  const [allUser, setAllUser] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const payload = {
          statusId: 1,
          page: 1,
          pageSize: 1000000,
          status: null,
          langId: localStorage.getItem("i18nextLngId")
        }
        const response = await getUserList(payload);
        const usersList = response.data.data;
        setAllUser(usersList);
      } catch (error) {
        console.log(error)
      }
    };
    fetchUser();

  }, [refreshData]);


  const getFullNameByEmail = (email) => {
    if (!email) return "-";

    const normalizedEmail = String(email).trim().toLowerCase();

    const user = allUser.find(
      (u) =>
        u.email &&
        u.email.trim().toLowerCase() === normalizedEmail
    );

    return user?.fullName || email;
  };

  const shiftsWithoutAll = useMemo(
    () => shiftsData.filter((shift) => shift.shiftId !== 0),
    [shiftsData]
  );

  const buildMissingUserIds = useCallback((rows) => {
    const missingCheckInUserIds = [
      ...new Set(
        rows
          .filter((e) => e.missingEvent === EVENT_STATUS.missingCheckIn)
          .map((e) => e.userId)
          .filter(Boolean)
      ),
    ];
    const missingCheckOutUserIds = [
      ...new Set(
        rows
          .filter((e) => e.missingEvent === EVENT_STATUS.missingCheckOut)
          .map((e) => e.userId)
          .filter(Boolean)
      ),
    ];
    return { missingCheckInUserIds, missingCheckOutUserIds };
  }, []);

  const canAdminEdit = (row) =>
    !isEmployee &&
    row?.eventType !== "PENDING_CHECK_IN" &&
    row?.eventType !== "PENDING_CHECK_OUT";

  const canAdminDelete = (row) =>
    !isEmployee &&
    row?.eventType &&
    row?.eventType !== "PENDING_CHECK_IN" &&
    row?.eventType !== "PENDING_CHECK_OUT";

  const canEmployeeEdit = (row) =>
    isEmployee &&
    (row?.eventType === "CHECK_IN" || row?.eventType === "CHECK_OUT");

  const canEmployeeDelete = (row) =>
    isEmployee &&
    (row?.eventType === "PENDING_CHECK_IN" ||
      row?.eventType === "PENDING_CHECK_OUT") &&
    row?.userId === profile?.userId;

  const handleEditEvent = (row) => {
    setSelectedEvent(row);
    if (!isEmployee) {
      setOpenEditEvent(true);
      return;
    }
    setOpenEditEventByUser(true);
  };

  const handleDeleteEvent = (row) => {
    setSelectedEvent(row);
    if (!isEmployee) {
      setOpenRemoveEvent(true);
      return;
    }
    setOpenRemoveRequestEvent(true);
  };

  const handleCloseEditEvent = () => {
    setOpenEditEvent(false);
    setSelectedEvent(null);
  };

  const handleCloseEditEventByUser = () => {
    setOpenEditEventByUser(false);
    setSelectedEvent(null);
  };

  const handleCloseRemoveEvent = () => {
    setOpenRemoveEvent(false);
    setSelectedEvent(null);
  };

  const handleCloseRemoveRequestEvent = () => {
    setOpenRemoveRequestEvent(false);
    setSelectedEvent(null);
  };

  const columnData = useMemo(
    () => [
      {
        field: "fullName",
        headerName: t("common.fullname"),
        flex: 1,
        filterable: true,
        hideable: true,
      },
      {
        field: "shiftName",
        headerName: t("common.shiftName"),
        hideable: true,
        flex: 1,

        rowSpanValueGetter: (value, row) =>
          row ? `${row.id}-${row.shiftName}` : value,

        valueFormatter: (value) => {
          if (value === null || value === undefined) return "-";
          const upper = String(value).toUpperCase();
          if (upper === "DEFAULT") return t("common.default");
          return value;
        },
      },
      {
        field: "eventType",
        headerName: t("common.content-115"),
        hideable: true,
        flex: 1,

        valueGetter: (params) => {
          const eventType = params;

          if (!eventType) return "-";

          return t(`attendance.${eventType}`);
        },

        renderCell: (params) => {
          const label = t(`attendance.${params.row.eventType}`);

          const missingEvent =
            params.row.missingEvent !== EVENT_STATUS.checkInOut;

          const missingLabel = `(${t(
            `attendance.${params.row.missingEvent}`
          )})`;

          const eventDate = new Date(params.row.timeGMT);

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const isPastEvent = eventDate < today;

          switch (params.row.eventType) {
            case "CHECK_OUT":
              return (
                <div
                  className="text-blue-500 flex items-center justify-start gap-1.5"
                  style={{ height: "100%" }}
                >
                  <p className="leading-5">{label}</p>
                  {missingEvent && isPastEvent && (
                    <p className="text-red-500 leading-5">
                      {missingLabel}
                    </p>
                  )}
                </div>
              );

            case "CHECK_IN":
              return (
                <div
                  className="text-green-500 flex items-center justify-start gap-1.5"
                  style={{ height: "100%" }}
                >
                  <p className="leading-5">{label}</p>
                  {missingEvent && isPastEvent && (
                    <p className=" text-red-500 leading-5">
                      {missingLabel}
                    </p>
                  )}
                </div>
              );

            default:
              return (
                <div
                  className="text-yellow-500 flex items-center justify-start gap-1.5"
                  style={{ height: "100%" }}
                >
                  <p className="leading-5">{label}</p>
                </div>
              );
          }
        },
      },
      {
        field: "sensorData",
        headerName: t("common.content-116"),
        hideable: true,
        flex: 1,
        rowSpanValueGetter: (value, row) =>
          row ? `${row.id}-${row.sensorData}` : value,
        valueFormatter: (value) => {
          return value === null || value === undefined || value === ""
            ? t("common.no-sensor-data")
            : `${value}`;
        },
      },
      {
        field: "timeGMT",
        headerName: `${t("common.content-036")} (GMT)`,
        hideable: true,
        flex: 1,
        rowSpanValueGetter: (value, row) =>
          row ? `${row.id}-${row.timeGMT}` : value,

        valueFormatter: (value) => {
          if (!value) return "-";

          // Parse UTC (hỗ trợ cả ISO và yyyy-MM-dd HH:mm:ss)
          let dt = DateTime.fromISO(value, { zone: "utc" });

          if (!dt.isValid) {
            dt = DateTime.fromFormat(
              value,
              "yyyy-MM-dd HH:mm:ss",
              { zone: "utc" }
            );
          }

          if (!dt.isValid) return "-";

          // ✅ Convert sang timezone của company (KHÔNG dùng timezone máy)
          const browserTZ = dayjs.tz.guess();
          const companyDt = browserTZ
            ? dt.setZone(browserTZ)
            : dt.toLocal(); // fallback an toàn

          return companyDt.toFormat(
            dateTimeFormat || "dd/MM/yyyy HH:mm:ss"
          );
        }
      },
      {
        field: "createdTime",
        headerName: t("common.created-time"),
        hideable: true,
        flex: 1,
        rowSpanValueGetter: (value, row) =>
          row ? `${row.id}-${row.createdTime}` : value,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return "-";

          const formattedDate = value
            ? format(new Date(value), dateTimeFormat || "dd/MM/yyyy HH:mm:ss")
            : "";

          return formattedDate;
        },
      },
      {
        field: "modifiedTime",
        headerName: t("common.modified-time"),
        hideable: true,
        flex: 1,
        rowSpanValueGetter: (value, row) =>
          row ? `${row.id}-${row.modifiedTime}` : value,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return "-";
          const formattedDate = value
            ? format(new Date(value), dateTimeFormat || "dd/MM/yyyy HH:mm:ss")
            : "";

          return formattedDate;
        },
      },
      // {
      //   field: "modifiedBy",
      //   headerName: t("common.approve-reject-by"),
      //   hideable: true, 
      //   flex: 1,
      //   valueGetter: (params) => {
      //     const email = params;
      //     return getFullNameByEmail(email) || email || t("common.not-processed-yet");
      //   },

      //   renderCell: (params) => (
      //     <Tooltip title={params.value} arrow>
      //       <span className="truncate">{params.value}</span>
      //     </Tooltip>
      //   ),
      // },
      {
        field: "option",
        headerName: t("common.options"),
        width: 100,
        minWidth: 100,
        hideable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        align: "left",
        headerAlign: "left",
        renderCell: (params) => {
          const row = params.row;
          const showEdit = canAdminEdit(row) || canEmployeeEdit(row);
          const showDelete = canAdminDelete(row) || canEmployeeDelete(row);

          if (!showEdit && !showDelete) {
            return null;
          }

          const iconBtnClass =
            "inline-flex items-center justify-center w-8 h-8 shrink-0 rounded-lg hover:bg-gray-100 transition cursor-pointer p-0";

          return (
            <div
              className="flex flex-nowrap items-center justify-start gap-1 h-full w-full"
              onClick={(e) => e.stopPropagation()}
            >
              {showEdit && (
                <Tooltip
                  title={
                    canAdminEdit(row)
                      ? t("common.edit-event")
                      : t("common.request-edit-event")
                  }
                  arrow
                >
                  <button
                    type="button"
                    className={iconBtnClass}
                    onClick={() => handleEditEvent(row)}
                  >
                    <EditNew20pxSvg width={20} height={20} />
                  </button>
                </Tooltip>
              )}
              {showDelete && (
                <Tooltip
                title={
                  t("button.delete")
                }
                arrow
              >
                <button
                  type="button"
                  className={`${iconBtnClass} hover:bg-red-100`}
                  onClick={() => handleDeleteEvent(row)}
                >
                  <DeleteIcon16pxSvg width={20} height={20} color="#D00D00" />
                </button>
                </Tooltip>
              )}
              
            </div>
          );
        },
      },
    ],
    [settings.dateFormat, settings.timeFormat, t, columnVisibilityModel, refreshData, allUser, isEmployee, profile?.userId]
  );

  useEffect(() => {
    const fetchData = async () => {
      const browserTZ = dayjs.tz.guess();
      const { from, to } = buildFromToByDateWithTZ(
        selectedDate,
        genaralSettingTimeZone || "UTC"
      );

      try {
        show();

        const { data } = await getEventList(
          page + 1,
          pageSize,
          from,
          to,
          (isAdmin ? selectedUser?.id : profile.userId) ?? "",
          selectedShift === "all" ? "" : selectedShift,
          isShowErrorLog,
          isShowEnableLog,
          localStorage.getItem("i18nextLngId"),
          selectGroup
        );

        const eventsList = Array.isArray(data?.data) ? data.data : [];
        const totalRecords =
          data?.pagination?.totalElements ?? eventsList.length;

        const totalPages = Math.ceil(totalRecords / pageSize);
        if (page >= totalPages && totalPages > 0) {
          setPage(0);
          return;
        }

        setRowCount(totalRecords);
        setFilteredRowCount(totalRecords);
        setRowData(eventsList);
        setFilteredRowData(eventsList);

        const firstRow = eventsList[0];
        if (firstRow) {
          onRowSelection({
            ...firstRow,
            missingEvent: isToday(selectedDate)
              ? EVENT_STATUS.checkInOut
              : firstRow.missingEvent,
          });
        } else {
          onRowSelection({});
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data));
          }
        } else {
          toast.error(t('common.network-timeout'));
          console.log(error);
        }
      } finally {
        hide();
      }
    };

    fetchData();
  }, [
    isShowErrorLog,
    genaralSettingTimeZone,
    selectedDate,
    selectedUser,
    selectedShift,
    page,
    pageSize,
    language,
    profile,
    isAdmin,
    t,
    refreshData,
    onRowSelection,
    selectGroup,
    isShowEnableLog,
    show,
    hide
  ]);

  const onRowsSelectionHandler = (selectedRowIds) => {
    const selectedRows = rowData.filter((row) =>
      selectedRowIds.includes(row.eventAttendanceId)
    );

    if (selectedRows.length) {
      onRowSelection(selectedRows[0]);
    }

    setRowSelectData(selectedRows);
  };

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [""],
  });

  useEffect(() => {
    if (!isShowErrorLog) {
      onErrorUsersChange({
        missingCheckInUserIds: [],
        missingCheckOutUserIds: [],
      });
      return;
    }

    onErrorUsersChange(buildMissingUserIds(filteredRowData));
  }, [isShowErrorLog, filteredRowData, buildMissingUserIds, onErrorUsersChange]);

  const searchableFields = [
    "fullName",
    "employeeCode",
    "shiftName",
    "shiftStart",
    "directionAndStatus",
    "eventTime",
  ];
  const removeVietnameseTones = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const handleFilterModelChange = (newModel) => {
    const searchText = newModel.quickFilterValues?.[0] || "";
    setTextSearch(searchText);

    setFilterModel(newModel);
    
    if (!searchText) {
      setFilteredRowData(rowData);
      setFilteredRowCount(rowData.length);
      setPage(0);
      return;
    }

    const lowerSearch = removeVietnameseTones(searchText.trim());

    const filtered = rowData.filter((row) =>
      searchableFields.some((field) => {
        const val = row[field];
        return (
          val !== null &&
          removeVietnameseTones(String(val)).includes(lowerSearch)
        );
      })
    );

    setFilteredRowData(filtered);
    setFilteredRowCount(filtered.length);
    setPage(0);
  };

  const handleRowsPerPageChange = (newPageSize) => {
    // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
    const size =
      typeof newPageSize === "number"
        ? newPageSize
        : parseInt(newPageSize.target.value, 10);

    setPage((prevPage) => {
      // index của record đầu tiên đang xem
      const firstRowIndex = prevPage * pageSize;

      // page mới sao cho vẫn chứa record đó
      const newPage = Math.floor(firstRowIndex / size);

      // phòng trường hợp vượt quá số trang
      const maxPage = Math.max(
        0,
        Math.ceil(filteredRowCount / size) - 1
      );

      return Math.min(newPage, maxPage);
    });

    setPageSize(size);
  };

  const hasRows = filteredRowData.length > 0;
  const gridHeight = hasRows ? 500 : 360;

  return (
    <>
      <div className="w-full min-w-0 max-w-full overflow-hidden">
        <div
          className={`w-full max-w-full ${hasRows ? "overflow-x-auto" : "overflow-x-hidden"}`}
        >
          <StyledDataGrid
      // rows={rowData}
      rows={filteredRowData}
      rowCount={filteredRowCount}
      paginationMode="client"
      filterModel={filterModel}
      onFilterModelChange={handleFilterModelChange}
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        height: gridHeight,
        "& .MuiDataGrid-scrollbar--vertical": {
          display: "none !important",
        },
        "& .MuiDataGrid-scrollbar--horizontal": {
          display: hasRows ? undefined : "none !important",
        },

        "& .MuiDataGrid-scrollbarFiller": {
          display: "none !important",
        },
        "& .MuiDataGrid-root": {
          width: "100%",
          maxWidth: "100%",
        },
        "& .MuiDataGrid-main": {
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        },
        "& .MuiDataGrid-columnHeaders": {
          paddingRight: 0,
        },
        "& .MuiDataGrid-topContainer": {
          paddingRight: 0,
        },

        "& .MuiDataGrid-virtualScroller": {
          overflow: hasRows ? "auto !important" : "hidden !important",
          scrollbarWidth: hasRows ? "thin" : "none",
        },
        "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
          width: hasRows ? 8 : 0,
          height: hasRows ? 8 : 0,
        },

        "& input[type=number]::-webkit-inner-spin-button, \
 & input[type=number]::-webkit-outer-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },

        "& input[type=number]": {
          textAlign: "center",
          MozAppearance: "textfield",
          WebkitAppearance: "none",
          padding: "5px !important",
          height: "100%",
          pointerEvents: "none",
          caretColor: "transparent",
          userSelect: "none",
          paddingTop: "8px !important",
          paddingBottom: "8px !important"
        },

      }}
      columns={columnData}
      // loading={gridLoading}
      getRowId={(r) => r.eventAttendanceId}
      slots={{
        // toolbar: CustomToolbar,
        pagination: CustomPagination,
        noRowsOverlay: NoRowOverlay,
        columnsPanel: CustomColumnsPanel,
      }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
          onRefresh,
          localeText: tableTranslated,
        },
        pagination: {
          page,
          count: filteredRowCount,
          rowsPerPage: pageSize,
          onPageChange: setPage,
          onRowsPerPageChange: handleRowsPerPageChange,
        },
      }}
      ignoreDiacritics
      localeText={tableTranslated}
      columnVisibilityModel={columnVisibilityModel}
      onColumnVisibilityModelChange={handleColumnVisibilityChange}
      onRowSelectionModelChange={onRowsSelectionHandler}
      initialState={{
        filter: {
          filterModel: {
            items: [],
            quickFilterValues: [""],
          },
        },
      }}
    // localeText={useMemo(() => generateTranslateMuiTable(t), [t])}
    />
        </div>
      </div>

      {openEditEvent && selectedEvent && (
        <EditEventDialog
          onClose={handleCloseEditEvent}
          usersData={usersData}
          shiftsData={shiftsWithoutAll}
          onRefresh={onRefresh}
          info={selectedEvent}
        />
      )}
      {openEditEventByUser && selectedEvent && (
        <EditEventDialogByUser
          onClose={handleCloseEditEventByUser}
          usersData={usersData}
          shiftsData={shiftsWithoutAll}
          onRefresh={onRefresh}
          info={selectedEvent}
        />
      )}
      {openRemoveEvent && selectedEvent && (
        <RemoveEventDialog
          userId={profile?.userId}
          onClose={handleCloseRemoveEvent}
          onRefresh={onRefresh}
          refreshData={refreshData}
          info={selectedEvent}
        />
      )}
      {openRemoveRequestEvent && selectedEvent && (
        <RemoveRequestEventDialog
          userId={profile?.userId}
          onClose={handleCloseRemoveRequestEvent}
          onRefresh={onRefresh}
        />
      )}
    </>
  );
};

export default EventsGridInfoTable;
